import React, { useState, useEffect } from 'react';
import { storage, firestore } from './firebaseConfig';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';

const GalleryInput = () => {
  const [title, setTitle] = useState('');
  const [media, setMedia] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [mediaItems, setMediaItems] = useState([]);
  const [selectedMediaId, setSelectedMediaId] = useState(null);
  const [existingMediaUrl, setExistingMediaUrl] = useState('');

  useEffect(() => {
    const fetchMediaItems = async () => {
      const galleryCollection = collection(firestore, 'gallery');
      const gallerySnapshot = await getDocs(galleryCollection);
      setMediaItems(gallerySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };

    fetchMediaItems();
  }, []);

  const handleAddOrUpdateMedia = async () => {
    if (title && (media || existingMediaUrl)) {
      setUploading(true);
      try {
        let mediaUrl = existingMediaUrl;

        if (media) {
          const storageRef = ref(storage, `gallery/${media.name}`);
          const uploadTask = uploadBytesResumable(storageRef, media);
          const snapshot = await new Promise((resolve, reject) => {
            uploadTask.on(
              'state_changed',
              null,
              (error) => reject(error),
              () => resolve(uploadTask.snapshot)
            );
          });
          mediaUrl = await getDownloadURL(snapshot.ref);
        }

        if (selectedMediaId) {
          const mediaDoc = doc(firestore, 'gallery', selectedMediaId);
          await updateDoc(mediaDoc, {
            title,
            mediaUrl,
            mediaType: media ? (media.type.includes('video') ? 'video' : 'image') : existingMediaUrl.includes('video') ? 'video' : 'image',
          });
        } else {
          await addDoc(collection(firestore, 'gallery'), {
            title,
            mediaUrl,
            mediaType: media ? (media.type.includes('video') ? 'video' : 'image') : existingMediaUrl.includes('video') ? 'video' : 'image',
          });
        }

        // Reset input fields
        setTitle('');
        setMedia(null);
        setUploading(false);
        setSelectedMediaId(null);
        setExistingMediaUrl('');
      } catch (error) {
        console.error('Error uploading media or saving item:', error);
      }
    }
  };

  const handleEditMedia = (mediaItem) => {
    setSelectedMediaId(mediaItem.id);
    setTitle(mediaItem.title);
    setExistingMediaUrl(mediaItem.mediaUrl);
    setMedia(null);
  };

  const handleDeleteMedia = async (mediaId, mediaUrl) => {
    try {
      const mediaDoc = doc(firestore, 'gallery', mediaId);
      await deleteDoc(mediaDoc);

      // Delete media from storage
      const mediaRef = ref(storage, `gallery/${mediaUrl.split('/').pop().split('?')[0]}`);
      await deleteObject(mediaRef);

      setMediaItems(mediaItems.filter(item => item.id !== mediaId));
    } catch (error) {
      console.error('Error deleting media item:', error);
    }
  };

  return (
    <div>
      <h2>{selectedMediaId ? 'Update Media' : 'Add Media to Gallery'}</h2>
      <input
        type="text"
        placeholder="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <input
        type="file"
        accept="image/*,video/*"
        onChange={(e) => setMedia(e.target.files[0])}
      />
      <button onClick={handleAddOrUpdateMedia} disabled={uploading}>
        {uploading ? 'Uploading...' : selectedMediaId ? 'Update Media' : 'Add Media'}
      </button>

      <h3>Existing Media</h3>
      <ul>
        {mediaItems.map(item => (
          <li key={item.id}>
            <strong>{item.title}</strong> ({item.mediaType})
            <button onClick={() => handleEditMedia(item)}>Edit</button>
            <button onClick={() => handleDeleteMedia(item.id, item.mediaUrl)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GalleryInput;
